import { render, staticRenderFns } from "./AddCircle.vue?vue&type=template&id=510a4b11&scoped=true"
import script from "./AddCircle.vue?vue&type=script&lang=js"
export * from "./AddCircle.vue?vue&type=script&lang=js"
import style0 from "./AddCircle.vue?vue&type=style&index=0&id=510a4b11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510a4b11",
  null
  
)

export default component.exports